module.exports = __webpack_public_path__ + "static/media/block-img-one.706e1930.svg";